import React, { useState } from "react"
import { useSidebarMenuQuery } from '../../hooks/use-sidebar-menu-query'
import { useCommonItemsQuery } from '../../hooks/use-common-items-query'
import styled from '@emotion/styled/macro'
import { Theme2 } from "../Layout"
import { RightRedArrow, LeftRedArrow } from "../SVGs"
import { CriminalDefense, PersonalInjury, FamilyLaw } from "../ResultsInterior"


const InteriorCaseStudiesNonPracticeAreasContainer = styled.div`
margin: 27px 0 3em 0;
padding-top: 50px;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
text-align: center;


hr{
  width: 48px;
  height: 5px;
  background-color: ${Theme2.colors.neutral};
  margin-bottom: 30px;
  border: none;
}
ul{
  margin-left: 0;
}
li{
  border-bottom: 2px solid ${Theme2.colors.neutral};
  display: grid;
  grid-template-columns: auto 20%;
  color: ${Theme2.colors.dark1};
  text-transform: uppercase;
  padding: 32px 31px 37px 51px;
  font-weight: 700;
  font-size: 15px;

  :hover{
  background-color: ${Theme2.colors.light2};
  color: ${Theme2.light};
}
}

.firstItem{
  border-top: none;
}

button{
  background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
}
`
const NotHidden = styled.div`
color: ${Theme2.colors.light};
  background-color: ${Theme2.colors.tertiary};
`
const InteriorCaseStudiesNonPracticeAreasTitle =styled.div` 
color: ${Theme2.colors.dark1};
font-size: 38px;
font-family: ${Theme2.fonts.alternateHeadings};
`

const InteriorCaseStudiesNonPracticeAreas = () =>{
  const[isHidden , setIsHidden] = useState({})
  const[isHidden2 , setIsHidden2] = useState({})
 
const toggleHidden = (key) => {
  setIsHidden(prev => Boolean(!prev[key]) ? {...prev, [key]: true} : {...prev, [key]: false});
}


  const data = useSidebarMenuQuery();
  const { commonItemsCaseResultSidebarHeading } = useCommonItemsQuery();
    return(
      <InteriorCaseStudiesNonPracticeAreasContainer>
        <InteriorCaseStudiesNonPracticeAreasTitle>{commonItemsCaseResultSidebarHeading}</InteriorCaseStudiesNonPracticeAreasTitle>
        <hr />
        <ul>
        
        {data.nodes.map(menuItem => {
          return(
            <>
                 <li key={menuItem.label} className={menuItem.cssClasses}>
                   <div className="menuItemLabel">{menuItem.label}</div><button key={menuItem.id} onClick={() =>toggleHidden(menuItem.id)}>{isHidden[menuItem.id] ? <LeftRedArrow /> : <RightRedArrow />}</button>
                   </li>
                   <>
                   {isHidden[menuItem.id] ?
                   
                   <>
                   {menuItem.label === "Criminal Defense Attorney" &&
                   (
                     <NotHidden>
<CriminalDefense />
                     </NotHidden>
    
  )
  }
  {menuItem.label === "Personal Injury Attorney" &&
                   (
                    <NotHidden>
      <PersonalInjury />
      </NotHidden>
    )
    }
    {menuItem.label === "Family Law Attorney" &&
                   (
                    <NotHidden>
        <FamilyLaw />
        </NotHidden>
      )
      }
                  </> : null
        
        }
          </> 
          </>        
          )
          
                })}
        </ul>
        
        </InteriorCaseStudiesNonPracticeAreasContainer>
    )
}

export default InteriorCaseStudiesNonPracticeAreas